import { render, staticRenderFns } from "./TablaDeImpresion.vue?vue&type=template&id=785b789f&scoped=true&"
import script from "./TablaDeImpresion.vue?vue&type=script&lang=js&"
export * from "./TablaDeImpresion.vue?vue&type=script&lang=js&"
import style0 from "./TablaDeImpresion.vue?vue&type=style&index=0&id=785b789f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b789f",
  null
  
)

export default component.exports